'use client'

import React from 'react'

import { EnvironmentTypeContext } from './EnvironmentTypeContext'
import { EnvironmentTypeEnum } from './EnvironmentTypeEnum'

export function EnvironmentTypeContextProvider({
  children,
  value,
}: {
  children: React.ReactNode
  value: EnvironmentTypeEnum
}) {
  return (
    <EnvironmentTypeContext.Provider value={value}>
      {children}
    </EnvironmentTypeContext.Provider>
  )
}
